import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import i18n from "../../../../i18n";
import {
  reportPublishCompare,
  getJournalSearch,
  computeMediator,
  reportPublish,
  checkMediator,
  getDoReport,
  getAnalyses,
  getBNModel,
  getDataset,
  getModels,
} from "../_lib/api";

export const fetchDatasetAsync = createAsyncThunk(
  "causal/fetchDataset",
  async (req) => await getDataset(req)
);

export const fetchBNModelAsync = createAsyncThunk(
  "causal/fetchBNModel",
  async (req) => await getBNModel(req)
);

export const fetchAnalysesAsync = createAsyncThunk(
  "causal/fetchAnalyses",
  async (req) => await getAnalyses(req)
);

export const fetchModelsAsync = createAsyncThunk(
  "causal/fetchModels",
  async (req) => await getModels(req)
);

export const fetchReportsAsync = createAsyncThunk(
  "causal/fetchReports",
  async (req) => await getDoReport(req)
);

export const fetchReportPublishAsync = createAsyncThunk(
  "causal/fetchReportPublish",
  async (req) => await reportPublish(req)
);

export const fetchReportPublishCompareAsync = createAsyncThunk(
  "causal/fetchReportPublishCompare",
  async (req) => await reportPublishCompare(req)
);

export const fetchCheckMediatorAsync = createAsyncThunk(
  "causal/fetchCheckMediator",
  async (req) => await checkMediator(req)
);

export const fetchComputeMediatorDataAsync = createAsyncThunk(
  "causal/fetchComputeMediator",
  async (req) => await computeMediator(req)
);

export const fetchJournalSearchDataAsync = createAsyncThunk(
  "causal/fetchJournalSearch",
  async (req) => await getJournalSearch(req)
);

export const causalSlice = createSlice({
  name: "causal",
  initialState: {
    datasetData: null,
    BNModelData: null,
    causalInferenceData: null,
    causalInferenceData1: null,
    causalInferenceData2: null,
    analyses: null,
    models: null,
    reports: null,
    analysis1: null,
    analysis2: null,
    model1: null,
    model2: null,
    report1: null,
    report2: null,
    chartData: null,
    chartData1: null,
    chartData2: null,
    publishData1: null,
    publishColumnProperties1: null,
    publishData2: null,
    publishColumnProperties2: null,
    distributionData: null,
    histogramData: null,
    outcomeNode: null,
    diOutcomeNode: null,
    variableType: null,
    shouldLoadOutcomeNodeGraph: false,
    isSavedReport: false,
    canCreateGraph: false,
    diSelectedNodes: [],
    showRobustnessResult: false,
    canSelectThreshold: false,
    mediators: null,
    nodeInfoSpinning: false,
    computeMediatorData: null,
    journalSearchSpinning: false,
    journalSearchData1: null,
    journalSearchData2: null,
    hoverMessageText: "",
    graphIsUpdating: false,
    stratificationOn: false,
    stratificationFuncOn: false,
    shouldUpdateStrat: false,
    stratifications: [],
    stratificationLabels: [],
    stratificationLabel: "",
    stratificationGroupA: "A",
    stratificationGroupB: "B",
    stratificationGroupC: "C",
    stratificationValue1: null,
    stratificationValue2: null,
    stratDistributionData: null,
    stratificationSubgroup: null,
    stratificationChartData: null,
  },
  reducers: {
    setCausalInferenceData: (state, action) => {
      state.causalInferenceData = action.payload;
    },
    setCausalInferenceData1: (state, action) => {
      state.causalInferenceData1 = action.payload;
    },
    setCausalInferenceData2: (state, action) => {
      state.causalInferenceData2 = action.payload;
    },
    setAnalysis1: (state, action) => {
      state.analysis1 = action.payload;
    },
    setAnalysis2: (state, action) => {
      state.analysis2 = action.payload;
    },
    setModel1: (state, action) => {
      state.model1 = action.payload;
    },
    setModel2: (state, action) => {
      state.model2 = action.payload;
    },
    setReport1: (state, action) => {
      state.report1 = action.payload;
    },
    setReport2: (state, action) => {
      state.report2 = action.payload;
    },
    setChartData: (state, action) => {
      state.chartData = action.payload;
    },
    setChartData1: (state, action) => {
      state.chartData1 = action.payload;
    },
    setChartData2: (state, action) => {
      state.chartData2 = action.payload;
    },
    setPublishData1: (state, action) => {
      state.publishData1 = action.payload;
    },
    setPublishData2: (state, action) => {
      state.publishData2 = action.payload;
    },
    setOutcomeNode: (state, action) => {
      state.outcomeNode = action.payload;
    },
    setDIOutcomeNode: (state, action) => {
      state.diOutcomeNode = action.payload;
    },
    setDistributionData: (state, action) => {
      state.distributionData = action.payload;
      state.shouldLoadOutcomeNodeGraph = true;
    },
    setHistogramData: (state, action) => {
      state.histogramData = action.payload;
      state.shouldLoadOutcomeNodeGraph = true;
    },
    setVariableType: (state, action) => {
      state.variableType = action.payload;
    },
    setShouldLoadOutcomeNodeGraph: (state, action) => {
      state.shouldLoadOutcomeNodeGraph = action.payload;
    },
    setIsSavedReport: (state, action) => {
      state.isSavedReport = action.payload;
    },
    setCanCreateGraph: (state, action) => {
      state.canCreateGraph = action.payload;
    },
    setDISelectedNodes: (state, action) => {
      state.diSelectedNodes = action.payload;
    },
    setShowRobustnessResult: (state, action) => {
      state.showRobustnessResult = action.payload;
    },
    setCanSelectThreshold: (state, action) => {
      state.canSelectThreshold = action.payload;
    },
    setNodeInfoSpinning: (state, action) => {
      state.nodeInfoSpinning = action.payload;
    },
    setComputeMediatorData: (state, action) => {
      state.computeMediatorData = action.payload;
    },
    setJournalSearchSpinning: (state, action) => {
      state.journalSearchSpinning = action.payload;
    },
    setJournalSearchData1: (state, action) => {
      state.journalSearchData1 = action.payload;
    },
    setJournalSearchData2: (state, action) => {
      state.journalSearchData2 = action.payload;
    },
    setHoverMessageText: (state, action) => {
      state.hoverMessageText = action.payload;
    },
    setGraphIsUpdating: (state, action) => {
      state.graphIsUpdating = action.payload;
    },
    setStratifications: (state, action) => {
      state.stratifications = action.payload;
    },
    setStratificationLabels: (state, action) => {
      state.stratificationLabels = action.payload;
    },
    setStratificationOn: (state, action) => {
      state.stratificationOn = action.payload;
    },
    setStratificationFuncOn: (state, action) => {
      state.stratificationFuncOn = action.payload;
    },
    setShouldUpdateStrat: (state, action) => {
      state.shouldUpdateStrat = action.payload;
    },
    setStratificationLabel: (state, action) => {
      state.stratificationLabel = action.payload;
    },
    setStratificationGroupA: (state, action) => {
      state.stratificationGroupA = action.payload;
    },
    setStratificationGroupB: (state, action) => {
      state.stratificationGroupB = action.payload;
    },
    setStratificationGroupC: (state, action) => {
      state.stratificationGroupC = action.payload;
    },
    setStratificationValue1: (state, action) => {
      state.stratificationValue1 = action.payload;
    },
    setStratificationValue2: (state, action) => {
      state.stratificationValue2 = action.payload;
    },
    setStratDistributionData: (state, action) => {
      state.stratDistributionData = action.payload;
    },
    setStratificationSubgroup: (state, action) => {
      state.stratificationSubgroup = action.payload;
    },
    setStratificationChartData: (state, action) => {
      state.stratificationChartData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDatasetAsync.fulfilled, (state, action) => {
        if (action.payload) {
          const data = action.payload;
          const columnsObject = {};
          const columnsLabelObject = {};
          for (let item of data.column_properties) {
            columnsObject[item.value] = item;
            columnsLabelObject[item.name] = item;
          }
          state.datasetData = {
            columns: columnsObject,
            columnsByLabel: columnsLabelObject,
          };
        } else {
          state.datasetData = null;
        }
      })
      .addCase(fetchBNModelAsync.fulfilled, (state, action) => {
        state.BNModelData = action.payload;
      })
      .addCase(fetchAnalysesAsync.fulfilled, (state, action) => {
        state.analyses = action.payload;
        if (action.payload.analyses.length > 0) {
          state.analysis1 = action.payload.analyses[0];
          state.analysis2 = action.payload.analyses[0];
        }
      })
      .addCase(fetchModelsAsync.fulfilled, (state, action) => {
        state.models = action.payload;
      })
      .addCase(fetchReportsAsync.fulfilled, (state, action) => {
        state.reports = action.payload;
      })
      .addCase(fetchReportPublishAsync.fulfilled, (state, action) => {
        let data = null;
        if (action.payload) {
          data = action.payload;
          state.publishData1 = data;
          if (
            data.dwmodel_report_publishment_1 &&
            data.dwmodel_report_publishment_1.dataset_metadata &&
            data.dwmodel_report_publishment_1.dataset_metadata.column_properties
          ) {
            const columnProperties =
              data.dwmodel_report_publishment_1.dataset_metadata
                .column_properties;
            const columnsObject = {};
            const columnsLabelObject = {};
            for (let item of columnProperties) {
              columnsObject[item.value] = item;
              columnsLabelObject[item.name] = item;
            }
            state.publishColumnProperties1 = {
              columns: columnsObject,
              columnsByLabel: columnsLabelObject,
            };
          }
        }
      })
      .addCase(fetchReportPublishCompareAsync.fulfilled, (state, action) => {
        let data = null;
        if (action.payload) {
          data = action.payload;
          state.publishData2 = data;
          if (
            data.dwmodel_report_publishment_1 &&
            data.dwmodel_report_publishment_1.dataset_metadata &&
            data.dwmodel_report_publishment_1.dataset_metadata.column_properties
          ) {
            const columnProperties =
              data.dwmodel_report_publishment_1.dataset_metadata
                .column_properties;
            const columnsObject = {};
            const columnsLabelObject = {};
            for (let item of columnProperties) {
              columnsObject[item.value] = item;
              columnsLabelObject[item.name] = item;
            }
            state.publishColumnProperties1 = {
              columns: columnsObject,
              columnsByLabel: columnsLabelObject,
            };
          }
          if (
            data.dwmodel_report_publishment_2 &&
            data.dwmodel_report_publishment_2.dataset_metadata &&
            data.dwmodel_report_publishment_2.dataset_metadata.column_properties
          ) {
            const columnProperties =
              data.dwmodel_report_publishment_2.dataset_metadata
                .column_properties;
            const columnsObject = {};
            const columnsLabelObject = {};
            for (let item of columnProperties) {
              columnsObject[item.value] = item;
              columnsLabelObject[item.name] = item;
            }
            state.publishColumnProperties2 = {
              columns: columnsObject,
              columnsByLabel: columnsLabelObject,
            };
          }
        }
      })
      .addCase(fetchCheckMediatorAsync.pending, (state) => {
        state.nodeInfoSpinning = true;
      })
      .addCase(fetchCheckMediatorAsync.fulfilled, (state, action) => {
        if (action.payload && action.payload.available_mediator_source_list) {
          state.mediators = action.payload.available_mediator_source_list;
          state.nodeInfoSpinning = false;
        } else {
          state.nodeInfoSpinning = false;
          state.mediators = null;
        }
      })
      .addCase(fetchComputeMediatorDataAsync.pending, (state) => {
        state.nodeInfoSpinning = true;
      })
      .addCase(fetchComputeMediatorDataAsync.fulfilled, (state, action) => {
        if (action.payload) {
          state.computeMediatorData = action.payload;
          state.nodeInfoSpinning = false;
        } else {
          state.nodeInfoSpinning = false;
          state.computeMediatorData = null;
        }
      })
      .addCase(fetchJournalSearchDataAsync.pending, (state) => {
        state.journalSearchSpinning = true;
      })
      .addCase(fetchJournalSearchDataAsync.fulfilled, (state, action) => {
        if (action.payload && action.payload) {
          state.journalSearchData1 = action.payload;
          state.journalSearchSpinning = false;
        } else {
          state.journalSearchSpinning = false;
          if (action.payload && action.payload.detail) {
            state.journalSearchData1 = action.payload;
          } else {
            state.journalSearchData1 = { detail: i18n.t("error-api-unknown") };
          }
        }
      });
  },
});

export const {
  setCausalInferenceData,
  setCausalInferenceData1,
  setCausalInferenceData2,
  setAnalysis1,
  setAnalysis2,
  setModel1,
  setModel2,
  setReport1,
  setReport2,
  setChartData,
  setChartData1,
  setChartData2,
  setPublishData1,
  setPublishData2,
  setOutcomeNode,
  setDIOutcomeNode,
  setDistributionData,
  setHistogramData,
  setVariableType,
  setShouldLoadOutcomeNodeGraph,
  setIsSavedReport,
  setCanCreateGraph,
  setDISelectedNodes,
  setShowRobustnessResult,
  setCanSelectThreshold,
  setNodeInfoSpinning,
  setComputeMediatorData,
  setJournalSearchSpinning,
  setJournalSearchData1,
  setJournalSearchData2,
  setHoverMessageText,
  setGraphIsUpdating,
  setStratificationOn,
  setStratificationFuncOn,
  setShouldUpdateStrat,
  setStratificationLabel,
  setStratificationGroupA,
  setStratificationGroupB,
  setStratificationGroupC,
  setStratificationValue1,
  setStratificationValue2,
  setStratifications,
  setStratificationLabels,
  setStratDistributionData,
  setStratificationSubgroup,
  setStratificationChartData,
} = causalSlice.actions;

export const selectDatasetData = (state) => state.causal.datasetData;
export const selectBNModelData = (state) => state.causal.BNModelData;
export const selectCausalInferenceData = (state) =>
  state.causal.causalInferenceData;
export const selectCausalInferenceData1 = (state) =>
  state.causal.causalInferenceData1;
export const selectCausalInferenceData2 = (state) =>
  state.causal.causalInferenceData2;
export const selectAnalyses = (state) => state.causal.analyses;
export const selectModels = (state) => state.causal.models;
export const selectReports = (state) => state.causal.reports;
export const selectAnalysis1 = (state) => state.causal.analysis1;
export const selectAnalysis2 = (state) => state.causal.analysis2;
export const selectModel1 = (state) => state.causal.model1;
export const selectModel2 = (state) => state.causal.model2;
export const selectReport1 = (state) => state.causal.report1;
export const selectReport2 = (state) => state.causal.report2;
export const selectChartData = (state) => state.causal.chartData;
export const selectChartData1 = (state) => state.causal.chartData1;
export const selectChartData2 = (state) => state.causal.chartData2;
export const selectPublishData1 = (state) => state.causal.publishData1;
export const selectPublishColumnProperties1 = (state) =>
  state.causal.publishColumnProperties1;
export const selectPublishData2 = (state) => state.causal.publishData2;
export const selectPublishColumnProperties2 = (state) =>
  state.causal.publishColumnProperties2;
export const selectDistributionData = (state) => state.causal.distributionData;
export const selectHistogramData = (state) => state.causal.histogramData;
export const selectOutcomeNode = (state) => state.causal.outcomeNode;
export const selectDIOutcomeNode = (state) => state.causal.diOutcomeNode;
export const selectVariableType = (state) => state.causal.variableType;
export const selectShouldLoadOutcomeNodeGraph = (state) =>
  state.causal.shouldLoadOutcomeNodeGraph;
export const selectIsSavedReport = (state) => state.causal.isSavedReport;
export const selectCanCreateGraph = (state) => state.causal.canCreateGraph;
export const selectDWTargetNodes = (state) => state.causal.diSelectedNodes;
export const selectCanSelectThreshold = (state) =>
  state.causal.canSelectThreshold;
export const selectMediators = (state) => state.causal.mediators;
export const selectNodeInfoSpinning = (state) => state.causal.nodeInfoSpinning;
export const selectComputeMediatorData = (state) =>
  state.causal.computeMediatorData;
export const selectJournalSearchSpinning = (state) =>
  state.causal.journalSearchSpinning;
export const selectJournalSearchData1 = (state) =>
  state.causal.journalSearchData1;
export const selectJournalSearchData2 = (state) =>
  state.causal.journalSearchData2;
export const selectHoverMessageText = (state) => state.causal.hoverMessageText;
export const selectGraphIsUpdating = (state) => state.causal.graphIsUpdating;
export const selectStratificationOn = (state) => state.causal.stratificationOn;
export const selectStratificationFuncOn = (state) =>
  state.causal.stratificationFuncOn;
export const selectShouldUpdateStrat = (state) =>
  state.causal.shouldUpdateStrat;
export const selectStratificationLabel = (state) =>
  state.causal.stratificationLabel;
export const selectStratificationGroupA = (state) =>
  state.causal.stratificationGroupA;
export const selectStratificationGroupB = (state) =>
  state.causal.stratificationGroupB;
export const selectStratificationGroupC = (state) =>
  state.causal.stratificationGroupC;
export const selectStratificationValue1 = (state) =>
  state.causal.stratificationValue1;
export const selectStratificationValue2 = (state) =>
  state.causal.stratificationValue2;
export const selectStratifications = (state) => state.causal.stratifications;
export const selectStratificationLabels = (state) =>
  state.causal.stratificationLabels;
export const selectStratDistributionData = (state) =>
  state.causal.stratDistributionData;
export const selectStratificationSubgroup = (state) =>
  state.causal.stratificationSubgroup;
export const selectStratificationChartData = (state) =>
  state.causal.stratificationChartData;

export default causalSlice.reducer;
